import { render, staticRenderFns } from "./AnalysisOfIron.vue?vue&type=template&id=b5f8ac58&"
import script from "./AnalysisOfIron.vue?vue&type=script&lang=js&"
export * from "./AnalysisOfIron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports